import { Route, Routes } from 'react-router-dom';
import CSCompany from './Companies';
import CSCoupon from './Coupons';
import CouponsView from './CouponList';
import Reports from './Reports';
import RedeemCoupon from './redeem-coupon';

function CouponRoutes() {
  return (
    <Routes>
      <Route path="companies" element={<CSCompany />} />
      <Route path="coupons" element={<CSCoupon />} />
      <Route path="redeem-coupon" element={<RedeemCoupon />} />
      <Route path="coupons/:id" element={<CouponsView />} />
      <Route path="reports" element={<Reports />} />
    </Routes>
  );
}

export default CouponRoutes;
